// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__16pHZ","savePackageButton":"ClientWallet_savePackageButton__y6klt"};